import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'
import { PersonalTrainerHead } from '@/index/service-category/personal-trainer/PersonalTrainerHead'
import { openModal } from 'service/modal-service'
import { getRequestJSON } from 'api/index/location-api'
import { useRouter } from 'next/router'
import { RequestProvider } from 'context/RequestContext'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-25'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts,
        requestCategorySettings
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings
    const router = useRouter()

    const [ requestForm, setRequestForm ] = useState(true)

    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)
    
    // useEffect(() => {
    //     setRequestForm(true)
    //     openModal(setRequestForm)
    // }, [])

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router]) 

  return (
    <>
      <Head>
        <title>9 Hacks for Effective Weight Loss in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Are you in Singapore and struggling to lose weight? Follow these most effective weight loss tips that works for the Singapore climate."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/weight-loss-singapore" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content="9 Hacks for Effective Weight Loss in Singapore"/>
        <meta property="og:description" content="Are you in Singapore and struggling to lose weight? Follow these most effective weight loss tips that works for the Singapore climate." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-25T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/belly-body-calories-diet.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/belly-body-calories-diet.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/weight-loss-singapore"/>
        <meta name="twitter:title" content="9 Hacks for Effective Weight Loss in Singapore"/> 
        <meta name="twitter:description" content="Are you in Singapore and struggling to lose weight? Follow these most effective weight loss tips that works for the Singapore climate."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/weight-loss-singapore" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/weight-loss-singapore"},"headline":"9 Hacks for Effective Weight Loss in Singapore","description":"Are you in Singapore and struggling to lose weight? Follow these most effective weight loss tips that works for the Singapore climate.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/belly-body-calories-diet.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-25T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"weight-loss-singapore"}]}]}`
        }}
        />
      </Head>      
      <div>
            <RequestProvider>
                <PersonalTrainerHead 
                    heroImage={s3Static + "diet.jpg"}
                    title="How to Lose Weight in Singapore: Top 9 Realistic Lifestyle Changes"
                heading="How to Lose Weight in Singapore: Top 9 Realistic Lifestyle Changes"
                    intro="Affordable personal training for weight loss"
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />
            </RequestProvider>
            {/* Intro + SEO Block */}
            <section className='max-w-5xl mx-auto pt-10 px-4 text-center space-y-2'>
                <h2 className='text-3xl font-bold'>
                    How to Lose Weight in Singapore: Top 9 Realistic Lifestyle Changes
                </h2>
                <p className='text-gray-600 text-base pt-3'>
                    Backed by local insights, these evidence-based habits are tailored for Singapore&apos;s busy lifestyle and humid climate.
                </p>
                <div className='text-gray-400 text-xs'>
                    <time dateTime={modifiedDate}>{new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>
            </section>
            {/* Main Article Content */}
            <article className='max-w-5xl mx-auto py-10 px-4 leading-8 text-[1rem]'>
                <p className='pb-4'>
                Struggling to lose weight in Singapore&apos;s fast-paced urban life? Whether you&apos;re battling late-night cravings or desk-bound habits, this guide will walk you through sustainable changes that work in our local context.
                </p>

                {/* Visual Intro */}
                <div className='relative h-80 w-full max-w-3xl mx-auto my-6'>
                <Image 
                    className='rounded-lg object-cover' 
                    src={s3Static + "blog/health+and+fitness/belly-body-calories-diet.jpg"} 
                    fill 
                    placeholder='blur' 
                    blurDataURL={s3Static + "placeholder.png"} 
                    alt='Singaporean woman measuring waist' 
                    priority 
                    sizes="(max-width: 768px) 100vw, 768px"
                    fetchPriority="high"
                />
                </div>

                {/* Section: Identify Habits */}
                <h2 className='text-xl font-semibold pt-6 pb-2'>Common Habits That Prevent Weight Loss</h2>
                <ul className='list-disc pl-6 space-y-1'>
                <li>Late dinners with heavy carbs like rice or noodles after 8pm</li>
                <li>Sleeping and waking up late, disrupting metabolism</li>
                <li>Snacking on chips, fries, and sugary treats</li>
                <li>Excessive carbohydrate consumption and sugary beverages</li>
                <li>Skipping meals and dehydration</li>
                <li>Inactive desk-bound lifestyle</li>
                </ul>

                {/* Section: Top 9 Lifestyle Changes */}
                <h2 className='text-2xl font-bold pt-10 pb-4 text-center uppercase'>
                9 Practical Lifestyle Changes to Lose Weight in Singapore
                </h2>

                {[
                {
                    title: 'Have an Early Dinner',
                    content: `Finish your dinner by 8pm. Cut down your carbs and increase lean proteins and veggies. Singapore’s late-night culture tempts you to snack, but sleeping early reduces this risk.`,
                },
                {
                    title: 'Sleep Early and Wake Early',
                    content: `Late nights trigger cortisol, a hormone linked to weight gain. Align your sleep with your body clock and embrace mornings with a walk in a nearby park.`,
                    image: "diet.jpg",
                    alt: "girl doing squats"
                },
                {
                    title: 'Choose Healthy Snacks',
                    content: `Replace chips with almonds, yogurt, or fruit. The Singapore workday is stressful — but snacking smart can prevent late-night bingeing.`,
                },
                {
                    title: 'Limit Simple Carbs',
                    content: `Switch from white rice and bread to complex carbs like oats, kidney beans, or brown rice. They break down slower and help you feel full longer.`,
                },
                {
                    title: 'Drink More Water',
                    content: `Singapore’s hot climate increases water needs. Aim for 8+ glasses daily to flush toxins and prevent dehydration — which is often mistaken for hunger.`,
                    image: "blog/health+and+fitness/diet-fat-health-weight.jpg",
                    alt: "woman drinking water"
                },
                {
                    title: 'Cut Sugary Drinks',
                    content: `Avoid canned beverages. One soft drink can undo a day’s worth of effort. Water or infused herbal teas are healthier alternatives.`,
                },
                {
                    title: 'Don’t Skip Meals',
                    content: `Skipping meals slows metabolism and encourages fat storage. Eat smaller portions more frequently to keep energy levels stable.`,
                },
                {
                    title: 'Eat a Balanced Plate',
                    content: `Follow the 40-30-15-15 rule: 40% vegetables, 30% protein, 15% healthy fats, 15% complex carbs.`,
                },
                {
                    title: 'Move More Daily',
                    content: `If gym time is tough, walk after dinner or try a weekend swim. Even 30 minutes of daily movement burns fat efficiently.`,
                }
                ].map((tip, idx) => (
                <div key={idx} className='pt-5'>
                    <h3 className='uppercase text-gray-500 font-semibold pb-1'>{idx + 1}. {tip.title}</h3>
                    <p>{tip.content}</p>
                    {tip.image && (
                    <div className='relative h-80 w-full max-w-3xl mx-auto my-4'>
                        <Image 
                        className='rounded-lg object-cover'
                        src={s3Static + tip.image}
                        fill
                        alt={tip.alt}
                        placeholder='blur'
                        blurDataURL={s3Static + "placeholder.png"}
                        sizes="(max-width: 768px) 100vw, 768px"
                        fetchPriority="low"
                        />
                    </div>
                    )}
                </div>
                ))}

                {/* CTA Section */}
                <div className='text-center py-8'>
                <p className='mb-4 font-medium'>
                    Not sure where to begin your fitness journey? A certified trainer can keep you accountable and track your progress.
                </p>
                <Link href="/sg/personal-trainer" className='inline-block px-4 py-3 border border-orange-500 text-orange-600 rounded-lg hover:bg-orange-50 transition'>
                    Get a weight loss personal trainer in Singapore in Singapore
                </Link>
                </div>
            </article>
            <h3 className='text-center text-xl uppercase pt-10'>You may also like</h3>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
